import React, { Component } from 'react';
import classNames from 'classnames';

import { type ConnectedProps } from 'react-redux';
import { type WithTranslation } from '@wix/yoshi-flow-editor';
import { MODAL_TYPE_DEMO_MODE } from '@wix/communities-blog-client-common';
import withTranslate from '../../hoc/with-translate';
import { keepFocus } from '../../services/keep-focus';
import { getViewMode } from '../../store/basic-params/basic-params-selectors';
import { getIsDemoMode } from '../../store/instance-values/instance-values-selectors';
import { getIsTemplate } from '../../store/topology/topology-selectors';
import Button from '../button';
import { connect } from '../runtime-context';
import styles from '../button/button.scss';

type OwnProps = {
  autoLogin?: boolean;
};

type Props = OwnProps & ConnectedProps<typeof connector> & Pick<WithTranslation, 't'>;

class LoginButton extends Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    if (this.props.autoLogin) {
      setTimeout(() => this.handleClick(), 100);
    }
  }

  handleClick() {
    const { viewMode, isDemoMode, openModal, requestLogin, isTemplate } = this.props;

    if (isDemoMode) {
      openModal(MODAL_TYPE_DEMO_MODE, { viewMode, isTemplate });
    } else {
      requestLogin();
    }
  }

  render() {
    const { t } = this.props;
    return (
      <Button className={classNames(styles.button, 'login-button')} onClick={this.handleClick}>
        {t('login-button.sign-up')}
      </Button>
    );
  }
}

const connector = connect((state, _ownProps: OwnProps, actions) => ({
  viewMode: getViewMode(state),
  isDemoMode: getIsDemoMode(state),
  isTemplate: getIsTemplate(state),
  openModal: actions.openModal,
  requestLogin: keepFocus(actions.requestLoginPromisified),
}));

export default connector(withTranslate(LoginButton));
